import { render, staticRenderFns } from "./PlatformSurveys.vue?vue&type=template&id=50f974ab&scoped=true&"
import script from "./PlatformSurveys.vue?vue&type=script&lang=js&"
export * from "./PlatformSurveys.vue?vue&type=script&lang=js&"
import style0 from "./PlatformSurveys.vue?vue&type=style&index=0&id=50f974ab&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f974ab",
  null
  
)

export default component.exports